import { FormValues } from '../../EditCounterpartyPaymentDetailsPopupContent.types';

export const checkHasThirdStepValues = (values: FormValues) => {
    const hasFilledAnyRoutingValue = Object.values(values.bankAccount?.routing ?? {}).some(Boolean);
    const hasFilledAnyAddressInfo = Object.values(values.legalEntity?.addressInfo ?? {}).some(Boolean);
    const hasFilledName = Boolean(
        values.legalEntity?.companyName || values.legalEntity?.firstName || values.legalEntity?.lastName
    );

    return (
        Boolean(values.bankAccount?.bankAccountName) ||
        hasFilledAnyRoutingValue ||
        hasFilledAnyAddressInfo ||
        hasFilledName
    );
};
